import React, { useState } from 'react';
import '../styles/Join.css';
import logo from '../assets/logo.webp';
import { useTranslation } from 'react-i18next';

const Join = () => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);
    
    return (
        <section id="unete" className="join-section">
            <div className="join-content">
                <div className="welcome-video-container">
                    <div className="welcome-video">
                        <iframe 
                            width="560" 
                            height="315" 
                            src="https://www.youtube.com/embed/-SqbEhWNzf4" 
                            frameBorder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                        ></iframe>
                    </div>
                    <div className="logo-overlay">
                        <img src={logo} alt="Corvus Nocta Logo" className="overlay-logo" />
                    </div>
                </div>
                <p>{t('join.description', 'Si quieres unirte a nuestra Federación primero entra en nuestro Discord')}</p>
                <div className="discord-container">
                    <a 
                        href="https://discord.gg/6xPtbF4Sn3" 
                        className="discord-button" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <i className="fab fa-discord"></i> {isHovered ? t('join.action', 'ÚNETE') : 'Discord'}
                    </a>
                </div>
                
                {/* Widget de Instagram */}
                <div className="instagram-widget">
                    <h3>{t('join.instagram.title', 'Síguenos en Instagram')}</h3>
                    <div className="instagram-feed">
                        <iframe
                            src="https://www.instagram.com/corvusnocta/embed"
                            width="400"
                            height="480"
                            frameBorder="0"
                            scrolling="no"
                            allowTransparency
                            className="instagram-embed"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Join; 